<template>
  <page>
    <X-O-L-Recovery-Listing />
  </page>
</template>
<script>
import XOLRecoveryListing from '@/components/core/claimManagement/xolRecovery/XOLRecoveryListing'
export default {
  props: {},
  components: {
    XOLRecoveryListing
  },
  data() {
    return {}
  }
}
</script>
